import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../axiosInstance';
import { errorResponseParser } from '../../utils/handlers';

export const getBillUploadType = createAsyncThunk(
  'getBillUploadType',
  async (_, { getState, rejectWithValue, dispatch }) => {
     const { userInfo } = getState().auth;
    const { companyId } = userInfo;
    try {
      const response = await axiosInstance.get(`/GetBillUploadType`, {
        params: {
          companyId: companyId
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const getExpenseBillsDetails = createAsyncThunk(
  'getExpenseBillsDetails',
  async (data, { rejectWithValue, dispatch, getState }) => {
    const { userInfo } = getState().auth;
    const { companyId } = userInfo;
    try {
      const response = await axiosInstance.get(`/getExpenseBills`, {
        params: {
          expenseId: data?.expenseId,
          activityDate: data?.activityDate,
          companyId: companyId
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

//uploadBill

export const uploadeBill = createAsyncThunk(
  'uploadeBill',
  async (data, { getState, rejectWithValue, dispatch }) => {
    const { userInfo } = getState().auth;
    const { employeeId, companyId } = userInfo;
    try {
      const response = await axiosInstance.post(`/uploadExpenseBill`, {
        ...data,
        employeeId: employeeId,
        companyId: companyId
      }, {
        headers: {
          "Content-Type": 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

//deleteUploadExpenseBill
export const deleteUploadType = createAsyncThunk(
  'deleteUploadType',
  async (id, { getState, rejectWithValue, dispatch }) => {
    const { userInfo } = getState().auth;
    const { companyId } = userInfo;
    try {
      const response = await axiosInstance.delete(`/deleteUploadType`, {
        params: {
          billUploadId: id,
          companyId: companyId
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const uploadExpenseBill = createSlice({
  name: 'uploadExpenseBill',
  initialState: {
    billUploadType: [],
    expenseBillsDetails: [],
    isUploadTypeDeleted: false,
    isUploadExpenseBillSubmitted: false,
    isAttachmentDetails: {}
  },
  reducers: {
    resetSubmittedFlags: (state) => {
      state.isUploadExpenseBillSubmitted = false
    },
    selectUploadBillAttachment: (state, action) => {
      state.isAttachmentDetails = action.payload
    },
    resetUploadBillDelete: (state) => {
      state.isUploadTypeDeleted = false
    }
  },
  extraReducers: (builder) => {
    //getBillUploadType
    builder
      .addCase(getBillUploadType.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBillUploadType.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.billUploadType = payload;
      })
      .addCase(getBillUploadType.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
        state.apiError = true;
      });

    //getExpenseBills
    builder
      .addCase(getExpenseBillsDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getExpenseBillsDetails.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.expenseBillsDetails = payload;
      })
      .addCase(getExpenseBillsDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
        state.apiError = true;
      });

    //uploadExpenseBill
    builder
      .addCase(uploadeBill.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(uploadeBill.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isUploadExpenseBillSubmitted = true;
      })
      .addCase(uploadeBill.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
        state.apiError = true;
      });

    //deleteUploadBillType
    builder
      .addCase(deleteUploadType.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteUploadType.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isUploadTypeDeleted = true;
      })
      .addCase(deleteUploadType.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
        state.apiError = true;
      });
  },
});

export const { resetSubmittedFlags, selectUploadBillAttachment, resetUploadBillDelete } = uploadExpenseBill.actions
export const uploadExpenseBillReducer = uploadExpenseBill.reducer;
